/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useState, useEffect } from 'react';
import { useRoom } from '../../../hooks/useRoom';
import { useVideoContext } from '../../../contexts/videoProvider/videoContext';
import { getVideoVendorApiKey, setVideoVendorApiKey, removeVideoVendorApiKey } from '@utils/videoVendorStorageUtils';

export namespace LocalRoomSetup {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    videoAuthToken: string;
    testSessionId?: string;
  }
}

export const LocalRoomSetup: React.FC<LocalRoomSetup.Props> = ({ videoAuthToken, testSessionId }) => {
  const { roomId } = useRoom();
  const { connect: connectToVideoProvider, videoProvider } = useVideoContext();
  const [apiKey, setAPIKey] = useState(getVideoVendorApiKey(roomId, videoProvider.name));

  useEffect(() => {
    setVideoVendorApiKey(roomId, videoAuthToken);
    setAPIKey(videoAuthToken);
    return () => {
      removeVideoVendorApiKey(roomId);
      setAPIKey('');
    };
  }, []);

  useEffect(() => {
    if (apiKey && testSessionId) {
      connectToVideoProvider(apiKey, testSessionId);
    }
  }, [apiKey]);

  return null;
};
